import { SuperTextElement } from './SuperTextElement';
import { TitleElement } from './TitleElement';
import { DescElement } from './DescElement';
import { useGlobalContext } from '@/components/Context/hooks/useGlobalContext';
import { AVAILABLE_THEMES } from '@/styles/constants';

interface IIntroTextContext {
  description?: string | null;
  title?: string | null;
  superText?: string | null;
  titleTag?: string | null;
}

export const IntroTextContext = ({
  superText,
  title,
  titleTag,
  description,
}: IIntroTextContext) => {
  const { themeName } = useGlobalContext();
  return (
    <>
      {superText && <SuperTextElement tag="sup" text={superText} />}
      {title && (
        <TitleElement
          tag={themeName === AVAILABLE_THEMES.suprema ? 'h3' : titleTag || 'div'}
          text={title}
        />
      )}
      {description && <DescElement data-test="text-description" tag="p" text={description} />}
    </>
  );
};
